import { nanoid } from "nanoid";
import toast from "react-hot-toast";

function convertToMaksArea(rleArray) {
  var maskArea = [];
  for (let i = 0; i < rleArray.length; i += 2) {
    maskArea = maskArea.concat(Array(rleArray[i]).fill(0));
    if (i + 1 !== rleArray.length) {
      maskArea = maskArea.concat(Array(rleArray[i + 1]).fill(1));
    }
  }
  return maskArea;
}

export const convertToRLE = (maskArea) => {
  const rleArray = [];
  let countZeros = 0;
  let countOnes = 0;
  for (let i = 0; i < maskArea.length; i++) {
    if (maskArea[i] === 0) {
      countZeros++;
      if (countOnes > 0) {
        rleArray.push(countOnes);
        countOnes = 0;
      }
    } else {
      countOnes++;
      if (countZeros > 0 || i == 0) {
        rleArray.push(countZeros);
        countZeros = 0;
      }
    }
  }
  if (countZeros > 0) {
    rleArray.push(countZeros);
  }
  if (countOnes > 0) {
    rleArray.push(countOnes);
  }
  return rleArray;
};

function minusMaskArea(baseArea, removeArea, width, height) {
  var resultArea = [...baseArea];
  for (var x = 0; x < width; ++x) {
    for (var y = 0; y < height; ++y) {
      var index = x * height + y;
      if (resultArea[index] === 1 && removeArea[index] === 1) resultArea[index] = 0;
    }
  }
  console.log(
    "base:",
    baseArea.filter((x) => x > 0).length,
    "remove:",
    removeArea.filter((x) => x > 0).length,
    "result:",
    resultArea.filter((x) => x > 0).length
  );

  return resultArea;
}

function combineMaskArea(baseArea, addedArea, width, height) {
  function checkPoint(x1, y1, x2, y2) {
    x1 = Math.max(0, Math.min(x1, width));
    y1 = Math.max(0, Math.min(y1, height));
    x2 = Math.max(0, Math.min(x2, width));
    y2 = Math.max(0, Math.min(y2, height));
    return (
      (baseArea[x1 * height + y1] === 1 && addedArea[x2 * height + y2] === 1) ||
      (addedArea[x1 * height + y1] === 1 && baseArea[x2 * height + y2] === 1)
    );
  }

  var combinedArea = [...baseArea];
  var connected = false;
  for (var x = 0; x < width; ++x) {
    for (var y = 0; y < height; ++y) {
      var index = x * height + y;
      if (combinedArea[index] === 1) continue;
      if (addedArea[index] === 1) {
        combinedArea[index] = 1;
        if (!connected && (checkPoint(x - 1, y, x + 1, y) || checkPoint(x, y - 1, x, y + 1))) {
          connected = true;
        }
        continue;
      }
      var maxgap = 6;
      for (var i = 1; i < maxgap; ++i) {
        if (checkPoint(x + i - maxgap, y, x + i, y) || checkPoint(x, y + i - maxgap, x, y + i)) {
          combinedArea[index] = 1;
          if (!connected) {
            connected = true;
          }
          break;
        }
      }
    }
  }
  if (!connected) {
    //toast.error("The attempt to add a new area was unsuccessful. The new area must be connected to an existing selected area.");
    //combinedArea = [...baseArea];
  }
  return combinedArea;
}

export const combineSegment = (selectedSegment, addedSegment, minus = false) => {
  var width = selectedSegment.width,
    height = selectedSegment.height;

  var combinedArea = minus
    ? minusMaskArea(selectedSegment.maskArea, addedSegment.maskArea, width, height)
    : combineMaskArea(selectedSegment.maskArea, addedSegment.maskArea, width, height);
  var result = processArea(combinedArea, width, height);
  var ids = selectedSegment.ids ?? [selectedSegment.id];
  ids = [...ids, addedSegment.id];
  //console.log('combinedArea', combinedArea)
  //console.log('result', result)
  return { ...selectedSegment, ...result, ids: ids };
};

const splitMask = (maskArea, width, height, minCnt = 500) => {
  const map = new Map();
  var mask1 = Array(width * height).fill(0);
  var newIndex = 0;
  for (var x = 0; x < width; ++x) {
    for (var y = 0; y < height; ++y) {
      var pos = x * height + y;
      if (maskArea[pos] === 0) continue;
      var upv = y > 0 ? mask1[pos - 1] : 0;
      var leftv = x > 0 ? mask1[pos - height] : 0;
      if (upv === 0 && leftv === 0) {
        var downv = y < height - 1 ? maskArea[pos + 1] : 0;
        var rightv = x < width - 1 ? maskArea[pos + height] : 0;
        if (downv === 1 || rightv === 1) {
          mask1[pos] = ++newIndex;
          map.set(newIndex, newIndex);
        }
      } else if (upv === 0 && leftv !== 0) mask1[pos] = leftv;
      else if (upv !== 0 && leftv === 0) mask1[pos] = upv;
      else {
        if (upv !== leftv) map.set(Math.max(upv, leftv), Math.min(upv, leftv));
        mask1[pos] = Math.min(upv, leftv);
      }
      //console.log('mask1[pos]', mask1[pos], upv, leftv)
    }
  }
  //console.log('map', map)
  //console.log('maskArea.filter(x => x===1).length', maskArea.filter(x => x > 0).length)
  //console.log('mask1.filter(x => x===1).length', mask1.filter(x => x > 0).length)
  var loop = 0;
  while (true) {
    var dirty = false;
    map.forEach((v, k, m) => {
      if (v !== k && map.has(v) && map.get(k) !== map.get(v)) {
        //console.log('k', k, 'v', v);
        dirty = true;
        map.set(k, map.get(v));
      }
    });
    if (!dirty || ++loop > 10000) break;
  }

  var partitionIds = [...new Set(map.values())].sort();
  if (partitionIds.length === 1) return [maskArea];
  var results = [];
  maskArea.fill(0);
  for (var i = 0; i < partitionIds.length; ++i) {
    var r = mask1.map((m) =>
      (m > 0 && m === partitionIds[i]) || map.get(m) === partitionIds[i] ? 1 : 0
    );
    if (minCnt > 0) {
      var cnts = r.filter((m) => m > 0).length;
      //console.log(i, cnts)
      if (cnts < minCnt) continue;
    }
    for (var j = 0; j < width * height; ++j) if (r[j] > 0) maskArea[j] = 1;
    results.push(r);
  }
  //console.log('maskArea', maskArea.filter((m) => m > 0).length)
  return results;
};

const expandMatrix = (maskArea, width, height) => {
  function checkPoint(x, y) {
    return y >= 0 && x >= 0 && y < height && x < width && maskArea[x * height + y] == 1;
  }

  let deltaArray = [
    { dx: -2, dy: 0 },
    { dx: -1, dy: -1 },
    { dx: 0, dy: -2 },
    { dx: -1, dy: 1 },
    { dx: 1, dy: -1 },
    { dx: 2, dy: 0 },
    { dx: 1, dy: 1 },
    { dx: 0, dy: 2 },
  ];

  var expandedArea = [...maskArea];
  for (var x = 0; x < width; ++x) {
    for (var y = 0; y < height; ++y) {
      if (expandedArea[x * height + y] == 1) continue;
      for (var delta of deltaArray) {
        if (checkPoint(x + delta.dx, y + delta.dy)) {
          expandedArea[x * height + y] == 1;
          break;
        }
      }
    }
  }
  //console.log('expandedArea', expandedArea)
  return expandedArea;
};

export const processArea = (maskArea, width, height) => {
  var areas = splitMask(maskArea, width, height);
  //console.log('maskArea', maskArea)
  let cnt = 0;
  var pointsArray = [];
  for (var area of areas) {
    var points = traceContour(area, width, height);
    if (points.length > 0) {
      for (var p of points) {
        p.x = Math.min(Math.max(0, p.x), width - 1) / width;
        p.y = Math.min(Math.max(0, p.y), height - 1) / height;
      }
      pointsArray.push(points);
    }
    cnt += area.filter((m) => m > 0).length;
  }

  return {
    segmentation: "",
    pointsArray: pointsArray,
    maskArea: maskArea,
    id: nanoid(),
    width: width,
    height: height,
    area: maskArea.filter((m) => m > 0).length,
  };
};

export const getLeftOverAreas = (segments, width, height) => {
  var results = [];
  var leftOverMask = Array(width * height).fill(1);
  for (var segment of segments) {
    for (var i = 0; i < width * height; ++i)
      if (segment.maskArea[i] == 1 && leftOverMask[i] == 1) leftOverMask[i] = 0;
  }
  var areas = splitMask(leftOverMask, width, height, 2000);

  // left over area will have lines align with edges, need to remove those edge lines.
  var checkDis = 5;
  let directions = [
    { dx: checkDis, dy: checkDis },
    { dx: checkDis, dy: 2 * checkDis },
    { dx: 2 * checkDis, dy: checkDis },
    { dx: checkDis, dy: -checkDis },
    { dx: checkDis, dy: 2 * -checkDis },
    { dx: 2 * checkDis, dy: -checkDis },
    { dx: -checkDis, dy: checkDis },
    { dx: -checkDis, dy: 2 * checkDis },
    { dx: 2 * -checkDis, dy: checkDis },
    { dx: -checkDis, dy: -checkDis },
    { dx: -checkDis, dy: 2 * -checkDis },
    { dx: 2 * -checkDis, dy: -checkDis },
  ];
  for (var area of areas) {
    var cleanarea = Array(width * height).fill(0);
    for (let x = 0; x < width; x++) {
      for (let y = 0; y < height; y++) {
        if (area[x * height + y] === 0) continue;
        for (var p of directions) {
          var px = x + p.dx;
          var py = y + p.dy;
          if (px >= 0 && px < width && py >= 0 && py < height && area[px * height + py] == 1) {
            cleanarea[x * height + y] = 1;
            break;
          }
        }
      }
    }
    var r = processArea(cleanarea, width, height);
    if (r.pointsArray.length > 0) results.push(r);
  }
  return results;
};

export const decodeSegment = (segmentation) => {
  var s = segmentation.counts;
  var p = 0;
  var cnts = [];
  var m = 0;
  while (s[p]) {
    var x = 0;
    var k = 0;
    var more = 1;
    while (more) {
      const c = s[p].charCodeAt(0) - 48;
      x |= (c & 0x1f) << (5 * k);
      more = c & 0x20;
      p++;
      k++;
      if (!more && c & 0x10) {
        x |= -1 << (5 * k);
      }
    }
    if (m > 2) {
      x += cnts[m - 2];
    }
    m++;
    cnts.push(x);
  }
  //console.log('segmentation', segmentation, 'cnts', cnts)
  var maskArea = convertToMaksArea(cnts);
  var expandedArea = expandMatrix(maskArea);
  return processArea(expandedArea, segmentation.size[1], segmentation.size[0]);
};

function findFirstPixel(maskArea, width, height) {
  for (let x = 0; x < width; x++) {
    for (let y = 0; y < height; y++) {
      if (maskArea[x * height + y] === 1) {
        return { x: x, y: y, dir: 3 };
      }
    }
  }
  return null;
}

function findNextPixel(maskArea, currentPixel, width, height) {
  let directions = [
    { dx: 0, dy: -1 }, // North 0
    { dx: 1, dy: -1 }, // Northeast 1
    { dx: 1, dy: 0 }, // East 2
    { dx: 1, dy: 1 }, // Southeast 3
    { dx: 0, dy: 1 }, // South 4
    { dx: -1, dy: 1 }, // Southwest 5
    { dx: -1, dy: 0 }, // West 6
    { dx: -1, dy: -1 }, // Northwest 7
  ];

  let dir = (currentPixel.dir + 6) % 8;
  for (let i = 0; i < 8; i++) {
    let dx = directions[dir].dx;
    let dy = directions[dir].dy;
    var y = currentPixel.y + dy,
      x = currentPixel.x + dx;
    if (y >= 0 && x >= 0 && y < height && x < width && maskArea[x * height + y] === 1) {
      return { x: x, y: y, dir: dir };
    }
    dir = (dir + 1) % 8;
  }
  return null; // No next pixel found
}

function traceContour(maskArea, width, height) {
  let contours = [];
  let currentPixel = findFirstPixel(maskArea, width, height);
  if (currentPixel === null) return contours;
  let startPixel = currentPixel;
  var loop = 0;
  do {
    contours.push({ x: currentPixel.x, y: currentPixel.y });
    let nextPixel = findNextPixel(maskArea, currentPixel, width, height);
    currentPixel = nextPixel;
    ++loop;
    if (loop >= 10000) return [];
  } while (currentPixel && (currentPixel.x !== startPixel.x || currentPixel.y !== startPixel.y));
  return contours;
}
